// extracted by mini-css-extract-plugin
export default {"root":"PasswordReset_root__p9K37"};